import { useQueries, useQuery } from '@tanstack/react-query';
import { portalApi } from '../services/portalApi';
import { queryKeys } from './queryKeys';

export function useStatsOverviewQueries(ranges, combine) {
  return useQueries({
    queries: ranges.map((range) => ({
      queryKey: queryKeys.stats.overview(range),
      queryFn: () => portalApi.statsOverview(range),
      staleTime: 5 * 60 * 1000
    })),
    combine
  });
}

export function useAnalytics(range, { enabled = true } = {}) {
  return useQuery({
    queryKey: queryKeys.stats.analytics(range),
    queryFn: () => portalApi.analytics(range),
    enabled,
    staleTime: 5 * 60 * 1000
  });
}
